module.exports = __webpack_public_path__ + "static/media/faraday-logo.6f6c122b.svg";